import kamala from '../../kamala'
import DefaultButton from './DefaultButton'

DefaultButton.install = function (Vue) {
  kamala(Vue)
  Vue.component(DefaultButton.name, DefaultButton)
}

export {
  DefaultButton,
}

export default DefaultButton
